import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onOpenLivePersonaEditor = action("onOpenLivePersonaEditor", event => ({
    event,
    owaType: "openLivePersonaEditor",
})) as OwaNovaActionUnion<"openLivePersonaEditor">;
